module.exports = __webpack_public_path__ + "5a7e53752b09dd75be44fa60cf3ce868.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/sp-license-info/sp-license-info.html
// module id = 1124
// module chunks = 0